module.exports = __webpack_public_path__ + "img/53.8a2d1a4d.jpg";